import { SecondPage } from './components/second-page'

export const SectionSix = () => {
  return <SecondPage />
}
